<!-- <wl-card heading="Consent Form - Annexure II"
  *ngIf="!kcc_form_disable && !consent_update_status && !consent_save_status"> -->
  <wl-card heading="Consent Form - Annexure II">
  <h2 class="text-center"> Loan Renewal Application Form</h2>
  <h3 class="text-center">Digital Renewal of UGC (KCC loans) of upto Rs.{{loanAmountInDecimals}} lakh</h3>


  <form novalidate [formGroup]="bankAccForm" (submit)="consentformSubmit()">
    <wl-card heading="Borrower Details">
      <!-- <wl-input type="text" label="IFSC Code" (submit)="verify(bankAccForm.value)" placeholder="IFSC Code" formControlName="ifsc_code"></wl-input>
    <wl-input type="text" label="Bank Account Number" placeholder="Bank Account Number" formControlName="bank_acc_no"></wl-input>
    -->
      <wl-input type="text" label="Name of the Borrower" placeholder="Name of the Borrower"
        formControlName="name_of_borrower" [readonly]="true"></wl-input>
      <!-- <wl-input type="text" label="Bank Account Number" placeholder="Bank Account Number" formControlName="bank_acc_no"></wl-input> -->
      <wl-input type="text" label="Name of Co Applicant/s" placeholder="Name of Co Applicant/s"
        formControlName="name_of_co_applicant" [readonly]="true"></wl-input>
      <wl-input type="text" label="Correspondence Address" placeholder="Correspondence Address"
        formControlName="corps_address" [readonly]="true"></wl-input>
      <wl-input type="text" label="Customer ID" placeholder="Customer ID" formControlName="customer_id"
        [readonly]="true"></wl-input>
      <wl-input type="text" label="Account No." placeholder="Account No." formControlName="bank_acc_no"
        [readonly]="true"></wl-input>
      <!-- <wl-input type="text" label="Certificate Number" placeholder="Certificate Number" formControlName="certificateNo"></wl-input>
    <wl-input type="text" label="Tax Paid" placeholder="Amount" formControlName="taxPaid"></wl-input> -->

      <!-- <p fxLayout="row" fxLayoutAlign="start center">
      <label fxFlex="30" fxShow fxHide.xs>Fiscal Year</label>
      <mat-select fxFlex.xs="100" fxFlex.gt-xs="50" placeholder="Select Fiscal Year" formControlName="fiscalYear">
        <mat-option *ngFor="let year of fiscalYears | async" [value]="year.name">{{year.name}}</mat-option>
      </mat-select>
    </p> -->

    </wl-card>

    <wl-progress [hidden]="isDataPending"></wl-progress>
    <!-- <wl-bank-acc-detail [detail]="detail"></wl-bank-acc-detail> -->
    <wl-card heading="Existing Loan Details">
      <div child-container class="table table-bordered table-responsive">
        <table class="table table-hover min-w-1200px">
          <thead>
            <tr>
              <th class="text-center">Type of Facilities</th>
              <th class="text-center">Existing Limit(in Rs)</th>
              <th class="text-center">Outstanding (in Rs)</th>
              <th class="text-center">ROI (%)
              </th>
              <th class="text-center">Margin (%)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <wl-input-nolabel type="text" class="text-center" formControlName="type_of_facility"
                  [readonly]="true"></wl-input-nolabel>
              </td>
              <td class="text-center">
                <wl-input-nolabel type="text" class="text-center" formControlName="existing_loan_in_lakhs"
                  [readonly]="true"></wl-input-nolabel>
              </td>
              <td class="text-center">
                <wl-input-nolabel type="text" class="text-center" formControlName="outstanding_as_on"
                  [readonly]="true"></wl-input-nolabel>
              </td>
              <td class="text-center">
                <wl-input-nolabel type="text" class="text-center" formControlName="roi" [readonly]="true">
                </wl-input-nolabel>
              </td>
              <td class="text-center">
                <wl-input-nolabel type="text" class="text-center" formControlName="margin" [readonly]="true">
                </wl-input-nolabel>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </wl-card>

    <wl-card heading="Renewal of Credit Limit">
      <wl-input type="text" label="Due date of Renewal of Credit Limit" formControlName="due_date_of_renew"
        [readonly]="true"></wl-input>
    </wl-card>

    <wl-card heading="Renewal of KCC">

      <label>
        <p><b>Whether Renewal of KCC Limit is Requested ?</b></p>
        <!-- <md-radio-group class="text-right pt-20px" [(ngModel)]="yeskccrdbtn1"
          formControlName="is_renewal_kcc_limit_required">
          <md-radio-button color="primary" class="example-margin" (click)="showkccform()" value="yes">Yes
          </md-radio-button>
          <md-radio-button color="primary" class="example-margin" (click)="consent_form_hide()" value="no">No
          </md-radio-button>
        </md-radio-group> -->
      </label>
      <br>
      <div *ngIf="kcc_form_flag">
        <div class="flex flex-row flex-start">
          <h3>A. Credit Facilities</h3>
        </div>
        <div child-container class="table-responsive">
          <table class="table table-hover table-bordered min-w-1000px">
            <thead>
              <tr>
                <th class="text-center">Existing (in Rs)</th>
                <th class="text-center">Requested (in Rs) (Not exceeding Rs{{loanAmountInDecimals}} Lakhs)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <wl-input type="text" class="text-center" placeholder="As per CBS" [readonly]="true"
                    formControlName="kcc_loanamt_cbs"></wl-input>
                </td>
                <td>
                  <wl-input type="number" label="(subject to assessment on the basis of  Cropping Pattern and Crop Area)"
                    placeholder="Rs." formControlName="kcc_loanamt_farmer" [(ngModel)]="proposedAmt"></wl-input>
                  <div *ngIf="bankAccForm.controls['kcc_loanamt_farmer'].errors" class="error-message-red">
                    Please enter value less than Rs{{loanAmountInDecimals}} Lakhs
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>




        <div class="flex flex-row flex-start">
          <h3>B. Proposed Cropping Pattern:</h3>
        </div>


        <form novalidate [formGroup]="multiCropDetailsForm">
          <div child-container class="table-responsive">
            <table class="table table-hover table-bordered">
              <tr>
                <th class="w-20px">Sr. <br> No.</th>
                <th class="w-50px">Cropping <br> season</th>
                <th class="text-center min-w-800px">Name of the Crop - List &nbsp;&nbsp;&nbsp; & &nbsp;&nbsp;&nbsp; Crop
                  Area - in Acres</th>
                <!-- <th colspan="1" class="text-left">Crop Area - in Acres</th> -->
                <th colspan="1" class="text-center w-20px">Actions</th>
              </tr>
              <tr>
                <td class="vertical-align-top pt-40px">1</td>
                <td class="vertical-align-top pt-40px">Kharif</td>
                <td colspan="1">
                  <div formArrayName="cropArrayKharif">
                    <table class="table table-borderless">
                      <tbody>
                        <tr *ngFor="let cropArray of cropArrayKharif().controls; let i=index" [formGroupName]="i">

                          <td class="text-center">
                            <br>
                            <wl-autocomplete placeholder="Choose a Crop" formControlName="kharif" [options]="newCrops"
                              (selected)="kharifSelectedEvent($event,i)" (keyup)="checkForEmpty()">
                            </wl-autocomplete>
                            <div class="display-none">
                              <wl-input type="text" formControlName="kharifId"></wl-input>
                            </div>
                          </td>
                          <td class="vertical-align-bottom text-left">
                            <wl-input-nolabel type="number" placeholder="Enter in Acres" (keyup)="totalacres(i)"
                              formControlName="kharif_acres" [readonly]="kharifDisabled"
                              ></wl-input-nolabel>
                              <!-- <input class="w-10pct" type="number" placeholder="Enter in Acres" (keyup)="totalacres(i)"
                              formControlName="kharif_acres" [readonly]="kharifDisabled"> -->
                          </td>
                          <td class="vertical-align-bottom">
                            <wl-input-nolabel type="number" placeholder="Enter in Guntas" (keyup)="totalacres(i)"
                              formControlName="kharif_guntas" [readonly]="kharifDisabled"></wl-input-nolabel>
                          </td>

                          <td class="vertical-align-middle">
                            <!-- <button (click)=" removeRowKharif(i)">Remove</button> -->
                            <i class="fa fa-trash-o deleteIcon fa-3x" (click)=" removeRowKharif(i)"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
                <td class="vertical-align-bottom text-center">
                  <!-- <button (click)="addKharifCrop()">Add</button> -->
                  <!-- <i class="far fa-plus fa-3x-square fa-3x" (click)="addKharifCrop()"></i> -->
                  <i class="fas fa-plus fa-3x" (click)="addKharifCrop()"></i>
                </td>
              </tr>
              <tr>
                <td class="vertical-align-top pt-40px">2</td>
                <td class="vertical-align-top pt-40px">Rabi</td>
                <td colspan="1">
                  <div formArrayName="cropArrayRabi">
                    <table class="table table-borderless">
                      <tbody>
                        <tr *ngFor="let cropArray of cropArrayRabi().controls; let i=index" [formGroupName]="i">

                          <td class="text-center">
                            <br>
                            <wl-autocomplete placeholder="Choose a Crop" formControlName="rabi" [options]="newCrops"
                              (selected)="rabiSelectedEvent($event,i)" (keyup)="checkForEmpty()">
                            </wl-autocomplete>
                            <div class="display-none">
                              <wl-input type="text" formControlName="rabiId"></wl-input>
                            </div>
                          </td>
                          <td class="vertical-align-bottom">
                            <wl-input-nolabel type="number" placeholder="Enter in Acres" (keyup)="totalacres(i)"
                              formControlName="rabi_acres" [readonly]="rabiDisabled"
                              ></wl-input-nolabel>
                          </td>
                          <td class="vertical-align-bottom">
                            <wl-input-nolabel type="number" placeholder="Enter in Guntas" (keyup)="totalacres(i)"
                              formControlName="rabi_gunta" [readonly]="rabiDisabled"></wl-input-nolabel>
                          </td>
                          <td class="vertical-align-middle">
                            <!-- <button (click)=" removeRowRabi(i)">Remove</button> -->
                            <i class="fa fa-trash-o deleteIcon fa-3x " (click)=" removeRowRabi(i)"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </td>
                <td class="vertical-align-bottom text-center">
                  <!-- <button (click)="addRabiCrop()">Add</button> -->
                  <i class="fas fa-plus fa-3x" (click)="addRabiCrop()"></i>
                </td>
              </tr>
              <tr>
                <td class="vertical-align-top pt-40px">3</td>
                <td class="vertical-align-top pt-40px">Summer</td>
                <td colspan="1">
                  <div formArrayName="cropArraySummer">
                    <table class="table table-borderless">
                      <tbody>
                        <tr *ngFor="let cropArray of cropArraySummer().controls; let i=index" [formGroupName]="i">

                          <td class="text-center">
                            <br>
                            <wl-autocomplete placeholder="Choose a Crop" formControlName="summer" [options]="newCrops"
                              (selected)="summerSelectedEvent($event,i)" (keyup)="checkForEmpty()">
                            </wl-autocomplete>
                            <div class="display-none">
                              <wl-input type="text" formControlName="summerId"></wl-input>
                            </div>
                          </td>
                          <td class="vertical-align-bottom">
                            <wl-input-nolabel type="number" placeholder="Enter in Acres" (keyup)="totalacres(i)"
                              formControlName="summer_acres" [readonly]="summerDisabled"
                              ></wl-input-nolabel>
                          </td>
                          <td class="vertical-align-bottom">
                            <wl-input-nolabel type="number" placeholder="Enter in Guntas" (keyup)="totalacres(i)"
                              formControlName="summer_gunta" [readonly]="summerDisabled"></wl-input-nolabel>
                          </td>
                          <td class="vertical-align-middle">
                            <!-- <button (click)=" removeRowSummer(i)">Remove</button> -->
                            <i class="fa fa-trash-o deleteIcon fa-3x" (click)=" removeRowSummer(i)"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </td>
                <td class="vertical-align-bottom text-center">
                  <!-- <button (click)="addSummerCrop()">Add</button> -->
                  <i class="fas fa-plus fa-3x" (click)="addSummerCrop()"></i>
                </td>
              </tr>
              <tr>
                <!-- <td colspan="2" class="text-right">Total</td> -->
                <td colspan="4" class="text-right">
                  <!-- <label>Total -->
                  <wl-input type="text" [readonly]="true" label="Total in Acres" [(ngModel)]="acressumnum"
                    formControlName="acressumnum"></wl-input>
                </td>
              </tr>
            </table>
          </div>
        </form>

        <div class="row">
          <p><b>
              Customer to select proposed crop from dropdown. (list of major crops for the state to be displayed and
              one option for others) if selected Others- customer to write the name of the crop in the box.
            </b></p>
        </div>
        <div class="row">
          <h3>C.Crop Insurance consent:</h3>
          <!-- <md-radio-group class="text-right pt-20px" formControlName="is_cropping_insurance_required">
            <md-radio-button color="primary" class="example-margin" value="yes">Yes</md-radio-button>
            <md-radio-button color="primary" class="example-margin" value="no">No</md-radio-button>
          </md-radio-group> -->
        </div>


        <!--  <label><b>A.  Credit Facilities</b>
    </label> <br>
    <label><b>B.   Proposed Cropping Pattern:</b>
    </label> -->
      </div>
    </wl-card>

    <wl-card>
      <div child-container class="table table-bordered table-responsive">
        <table class="table table-hover table-bordered min-w-1200px">
          <thead>
            <tr>
              <th class="text-center">Type of Facilities</th>
              <th class="text-center">Requested Limit (in Rs)</th>
              <th class="text-center">Rate of Interest (%)</th>
              <th class="text-center">Minimum Margin(%)</th>
              <th class="text-center">Securities & </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td class="text-center">
                <wl-input-nolabel type="text" placeholder="CCAGR" formControlName="type_of_facilities"
                  [readonly]="true"></wl-input-nolabel>
              </td>
              <td class="text-center">
                <wl-input-nolabel type="text" placeholder="(As entered above max upto Rs {{loanAmountInDecimals}} lakhs)" [readonly]="true"
                  [(ngModel)]="proposedAmt" formControlName="proposed_limit"></wl-input-nolabel>
              </td>
              <td>
                <wl-input-nolabel type="text" class="text-center" placeholder="Rate of Interest"
                  formControlName="rate_of_interest" [readonly]="true"></wl-input-nolabel>
              </td>
              <td>
                <wl-input-nolabel type="text" class="text-center" placeholder="Minimum Margin"
                  formControlName="minimum_margin" [readonly]="true"></wl-input-nolabel>
              </td>
              <td>
                <wl-input-nolabel type="text" class="text-center"
                  placeholder="(No details to be given here only text as under): Existing terms of sanction to continue "
                  [readonly]="true" formControlName="securities"></wl-input-nolabel>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
      <p>
        * I/We hereby extent my consent for above mentioned KCC account on existing terms and conditions.
      </p>
    </wl-card>


    <wl-card heading="Declaration">
      <label>
        <p class="text-justify-custom">
        <input class="display-inline-block" formControlName="declaration" type="checkbox" required />
          I/ We hereby certify that all information furnished above is true, correct and complete. I/ We have not availed any KCC/ Crop Loan except as indicated in the application. There is no overdue/ statutory dues against me/us. No legal action has been/ is being taken/ initiated against me/us by any Bank/FIs. I/We shall furnish all other information that may be required in connection with my/ our application that this may also be exchanged by you with any agency you may deemed fit and you, your representatives or Reserve Bank of India or any other agency as authorized by you, may, at any time, inspect/verify my/our assets, books of accounts etc. You may take appropriate safeguards/action for recovery of Bank’s dues including publication of defaulter’s name in website/submission to RBI; further agree that my/our loan shall be governed by the rules of your Bank which may be in force from time to time. I/ We hereby authorise Union Bank of India to fetch my/ our CIC report from Credit Bureau Agency
        </p> 
      </label>
      <!-- <wl-input type="checkbox"    formControlName="consent_declaration"></wl-input> -->
      <!-- <label for="declaration" class="ml-10px">  I/ We hereby certify that all information furnished above is true, 
        correct and complete that I/ We have not availed any KCC/ Crop Loan except as indicated in the application;
        that there is no overdue/ statutory dues against me/us; that no legal action has been/ is being taken/ initiated against me/us by any Bank/FIs. 
        I/We shall furnish all other information that may be required in connection with my/ our application that this may also be exchanged by you with 
        any agency you may deemed fit and you, your representatives or Reserve Bank of India or any other agency as authorized by you, may, at any time, 
        inspect/verify my/our assets, books of accounts etc. You may take appropriate safeguards/action for recovery of Bank’s dues including publication 
        of defaulter’s name in website/submission to RBI; further agree that my/our loan shall be governed by the rules of your Bank which may be in 
        force from time to time.</label><br> -->


    </wl-card>
    <div class="text-center pr-20px">
      <br>
      <wl-button-nolabel [disabled]="!bankAccForm.valid">Submit</wl-button-nolabel>
    </div>

  </form>




</wl-card>


<wl-card heading="Renewal Consent Form Confirmation" *ngIf="kcc_form_disable" id="kcc_form">
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <h3 id="ConsentText" class="text-center">Thank you for your response. The Union Bank branch
    will contact you for further process</h3>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>

</wl-card>

<!-- <wl-card heading="Renewal Consent Form Confirmation" *ngIf="consent_update_status || consent_save_status" id="kcc_form">
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <h3 id="ConsentText" class="text-center">Thank you. Your response has been saved. The Union Bank branch will
    contact you for further process.</h3>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>

</wl-card> -->


<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">